export default __webpack_public_path__ + "static/media/folha_g.63d65ddc.png";